export default {
    init: () => {
        global = {
            ...global,
            github: 'https://github.com/Malik-93',
            twitter: 'https://twitter.com/Hafiz786990',
            instagram: 'https://www.instagram.com/mudassir_093',
            linkedin: 'https://www.linkedin.com/in/muhammad-mudassir-075777130',
            email: 'malikjrw147@gmail.com',
            mobile: '+923039839093',
        }
    }
}